import { withRouter, useRouteMatch, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, useRef } from "react";
import PhoneInput from "react-phone-input-2";
import { Api, auth } from "../provider/firebase";
import { signInWithPhoneNumber, RecaptchaVerifier, signInWithCustomToken } from "firebase/auth";
import { somethingWentWrong } from "../provider/functions";
import { createRef } from "react";
export default withRouter(PayCart);

const styles = {
  pageContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #fafafa 0%, #f0f0f0 100%)',
    paddingBottom: 120,
  },
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  backButton: {
    width: 44,
    height: 44,
    borderRadius: 14,
    background: '#fff',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    fontSize: 18,
    color: '#333',
    flexShrink: 0,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: '-0.5px',
    margin: 0,
    lineHeight: 1.2,
  },
  shopName: {
    display: 'block',
    fontSize: 13,
    fontWeight: 400,
    opacity: 0.6,
    marginTop: 2,
  },
  formContainer: {
    padding: '0 16px',
  },
  formCard: {
    background: '#fff',
    borderRadius: 24,
    padding: 28,
    marginBottom: 16,
    boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
    border: '1px solid rgba(0,0,0,0.04)',
    textAlign: 'center',
  },
  iconCircle: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 36,
    margin: '0 auto 24px',
    color: '#fff',
  },
  cardTitle: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 8,
  },
  cardDescription: {
    fontSize: 14,
    opacity: 0.7,
    marginBottom: 32,
    lineHeight: 1.5,
  },
  codeInputContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 10,
    marginBottom: 24,
  },
  codeInput: {
    width: '100%',
    maxWidth: 280,
    padding: '18px 20px',
    borderRadius: 16,
    border: '2px solid rgba(0,0,0,0.1)',
    fontSize: 24,
    fontWeight: 700,
    textAlign: 'center',
    letterSpacing: 12,
    background: 'rgba(0,0,0,0.02)',
    outline: 'none',
    margin: '0 auto',
  },
  codeInputFocused: {
    borderColor: '#000',
  },
  helperText: {
    fontSize: 13,
    opacity: 0.5,
    marginTop: 16,
  },
  bottomSheet: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: '#fff',
    borderRadius: '24px 24px 0 0',
    padding: '20px 20px 28px',
    boxShadow: '0 -4px 30px rgba(0,0,0,0.1)',
    zIndex: 100,
  },
  submitButton: {
    width: '100%',
    padding: '16px 24px',
    borderRadius: 14,
    border: 'none',
    background: '#000',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    letterSpacing: '-0.2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
  },
  submitButtonDisabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
};

function PayCart({ history }) {
  const dispatch = useDispatch();
  let match = useRouteMatch();
  const isWebStore = match.params.table == "webstore" || match.params.table == "online";
  const language = useSelector((state) => state.language.data);
  const [loading, setloading] = useState(false);
  const { state } = useLocation();

  const [onaykodu, setonaykodu] = useState("");
  const serverReducer = useSelector((state) => state.server.data);
  const tables = useSelector((state) => state.tables.data);
  const cart = useSelector((state) => state.cart.data);
  const _inputref = createRef();

  useEffect(() => {
    console.log(state)
    if (!window.confirmationResult && !state) {
      history.goBack();
      return;
    }
    const subscribe = auth.onAuthStateChanged((userData) => {
      if (userData) {
        if (isWebStore) {
          history.replace((match.params.server ? "/" + match.params.server : "") + "/" + match.params.table + "/paywebstore")
        } else if (serverReducer.auth && match.params.table != "undefined") {
          history.replace((match.params.server ? "/" + match.params.server : "") + "/" + match.params.table + "/paytable")
        }
      }
    });
    return () => subscribe();
  }, []);

  useEffect(() => {
    _inputref.current?.focus();
  }, [_inputref.current])

  function afterLogin(res) {
    setloading(false);
    if (res.user) {
      if (isWebStore) {
        history.replace((match.params.server ? "/" + match.params.server : "") + "/" + match.params.table + "/paywebstore")
      } else if (serverReducer.auth) {
        history.replace((match.params.server ? "/" + match.params.server : "") + "/" + match.params.table + "/paytable")
      } else {
        history.replace((match.params.server ? "/" + match.params.server : "") + "/webstore/paywebstore")
      }
    } else {
      alert("Login failed!")
    }
  }

  function gonder() {
    setloading(true);
    if (state?.provider == "manuel") {
      return Api.post("/verifyPhone", { ...state, code: onaykodu }).then((response) => {
        if (response?.data?.data) {
          signInWithCustomToken(auth, response.data.data).then(afterLogin)
        }
      }).finally(() => {
        setloading(false);
      })
    }
    window.confirmationResult?.confirm(onaykodu).then((res) => {
      afterLogin(res)
    }).catch((err) => {
      console.log(err, onaykodu)
      alert(err.code)
      setloading(false)
    })
  }

  return (
    <div style={styles.pageContainer}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => history.goBack()}>
          <i className="fa fa-arrow-left" />
        </button>
        <div>
          <h1 style={{ ...styles.headerTitle, color: serverReducer.textColor }}>
            {language.login_sayfasi_baslik}
          </h1>
          <span style={{ ...styles.shopName, color: serverReducer.textColor }}>{serverReducer.title}</span>
        </div>
      </div>

      {/* Steps - Modern Progress Bar */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 20px 28px',
        gap: 0,
      }}>
        {/* Step 1 - Menu (Completed) */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(76, 175, 80, 0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
          }}>
            <i className="fa fa-check" style={{ color: '#4CAF50', fontSize: 14 }}></i>
          </div>
          <span style={{ fontSize: 11, fontWeight: 500, color: serverReducer.textColor, opacity: 0.6 }}>{language.menu}</span>
        </div>

        {/* Line 1-2 */}
        <div style={{ flex: 0.5, height: 3, background: '#4CAF50', borderRadius: 2, marginBottom: 22 }}></div>

        {/* Step 2 - Sepet (Completed) */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(76, 175, 80, 0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
          }}>
            <i className="fa fa-check" style={{ color: '#4CAF50', fontSize: 14 }}></i>
          </div>
          <span style={{ fontSize: 11, fontWeight: 500, color: serverReducer.textColor, opacity: 0.6 }}>{language.sepet}</span>
        </div>

        {/* Line 2-3 */}
        <div style={{ flex: 0.5, height: 3, background: '#4CAF50', borderRadius: 2, marginBottom: 22 }}></div>

        {/* Step 3 - Verify (Active) */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
          <div style={{
            width: 40, height: 40, borderRadius: '50%',
            background: "#e74c3c" || '#000',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
            boxShadow: `0 4px 14px ${"#e74c3c" || '#000'}40`,
          }}>
            <span style={{ color: '#fff', fontSize: 14, fontWeight: 700 }}>3</span>
          </div>
          <span style={{ fontSize: 11, fontWeight: 600, color: serverReducer.textColor }}>{language.dogrulama || "Doğrulama"}</span>
        </div>

        {/* Line 3-4 */}
        <div style={{ flex: 0.5, height: 3, background: 'rgba(0,0,0,0.1)', borderRadius: 2, marginBottom: 22 }}></div>

        {/* Step 4 - Ödeme (Pending) */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(0,0,0,0.06)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
          }}>
            <span style={{ color: 'rgba(0,0,0,0.3)', fontSize: 13, fontWeight: 600 }}>4</span>
          </div>
          <span style={{ fontSize: 11, fontWeight: 500, color: serverReducer.textColor, opacity: 0.4 }}>{language.odeme}</span>
        </div>
      </div>

      {/* Form */}
      <div style={styles.formContainer}>
        <div style={styles.formCard}>
          <div style={{ ...styles.iconCircle, background: `linear-gradient(135deg, ${"#e74c3c" || '#000'}, ${"#e74c3c" || '#333'})` }}>
            <i className="fa fa-shield-alt"></i>
          </div>
          <h2 style={{ ...styles.cardTitle, color: serverReducer.textColor }}>
            {language.onay_kodu_baslik || "Onay Kodunu Girin"}
          </h2>
          <p style={{ ...styles.cardDescription, color: serverReducer.textColor }}>
            {language.telefon_onay_aciklama || "Telefonunuza gönderilen 6 haneli doğrulama kodunu girin."}
          </p>

          <input
            type="text"
            ref={_inputref}
            value={onaykodu}
            onChange={(e) => setonaykodu(e.target.value)}
            placeholder="••••••"
            maxLength={6}
            style={{
              ...styles.codeInput,
              borderColor: onaykodu.length > 0 ? (serverReducer.bgcolor1 || '#000') : 'rgba(0,0,0,0.1)',
            }}
          />

          <p style={{ ...styles.helperText, color: serverReducer.textColor }}>
            <i className="fa fa-info-circle" style={{ marginRight: 6 }}></i>
            {language.kod_gelmedi_mi || "Kod gelmedi mi? Birkaç dakika bekleyin veya tekrar deneyin."}
          </p>
        </div>
      </div>

      {/* Bottom Sheet */}
      <div style={styles.bottomSheet}>
        <button
          style={{
            ...styles.submitButton,
            background: "#e74c3c" || '#000',
            ...(loading || onaykodu.length < 4 ? styles.submitButtonDisabled : {})
          }}
          disabled={loading || onaykodu.length < 4}
          onClick={gonder}
        >
          {loading ? (
            <div className="spinner-border spinner-border-sm text-light" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <>
              <i className="fa fa-check-circle"></i>
              {language.telefon_onay_gonder || "Doğrula"}
            </>
          )}
        </button>
      </div>
    </div>
  );
}
